import { IVasInfo } from '~/src/api/profile/vas/getVasInfo';
import * as ActionCreators from '~/src/store/actionCreators/vas';
import {
    VAS_ANTIVIRUS_LOAD_ERROR,
    VAS_ANTIVIRUS_LOADED,
    VAS_ANTIVIRUS_LOADING,
    VAS_LOAD_ERROR,
    VAS_LOADED,
    VAS_LOADING,
    VAS_DISABLING_STATUS_CHANGE,
    VAS_SET_VAS_ERROR,
} from '~/src/store/actionTypes/vas';
import { InferValueTypes, THydrateAction } from '~/src/store';
import { HYDRATE } from 'next-redux-wrapper';

export enum EVasDisablingStatus {
    default,
    disabling,
    disablingError,
    disabled
}

export interface IVasStore {
    isLoading: boolean,
    vasDisablingStatus: EVasDisablingStatus,
    errorMessage: string | null
    default: IVasInfo[],
    antivirus: IVasInfo[],
    loaded: number | null
}

const INITIAL_STATE: IVasStore = {
    vasDisablingStatus: EVasDisablingStatus.default,
    errorMessage: null,
    loaded: null,
    isLoading: false,
    default: [],
    antivirus: [],
};

type TActions = ReturnType<InferValueTypes<typeof ActionCreators>> | THydrateAction;

export default function reducer(state = INITIAL_STATE, action: TActions): IVasStore {
    switch (action.type) {
        case HYDRATE:
            return action.payload.vas;
        case VAS_LOADING:
        case VAS_ANTIVIRUS_LOADING:
            return {
                ...state,
                isLoading: true,
            };
        case VAS_LOADED:
            return {
                ...state,
                isLoading: false,
                default: action.payload,
                loaded: (new Date()).getTime()
            };
        case VAS_LOAD_ERROR:
        case VAS_ANTIVIRUS_LOAD_ERROR:
            return {
                ...state,
                isLoading: false,
            };
        case VAS_ANTIVIRUS_LOADED:
            return {
                ...state,
                isLoading: false,
                antivirus: action.payload,
            };
        case VAS_DISABLING_STATUS_CHANGE:
            return {
                ...state,
                vasDisablingStatus: action.payload
            };
        case VAS_SET_VAS_ERROR:
            return {
                ...state,
                errorMessage: action.payload
            };
        default:
            return state;
    }
}

